import React, { useRef, useEffect, useState } from "react";

class InputCurrency extends React.Component {
  constructor(props) {
    super(props);
    // this.videoEl = React.createRef();
    this.getValue = this.getValue.bind(this);
  }
  getValue() {
    if (this.range.value) {
      return parseFloat(this.range.value);
    }
  }

  render() {
    const { value, onUpdate, ...rest } = this.props;
    return (
      <input
        {...rest}
        ref={(node) => (this.range = node)}
        type="number"
        step="any"
        className="input-currency"
        style={{ textAlign: "right" }} // Align text to the right
      />
    );
  }
}

export default InputCurrency;
